import type {FilterObject} from 'nutshell-core/types';

import {SMS_EDITION_FILTER_KEYS} from '../consts';

export const editionFieldFilterFunction = (fieldName: string) => {
    // @ts-expect-error
    const editionFieldKeys = SMS_EDITION_FILTER_KEYS.concat(['period']);

    // @ts-expect-error
    return !editionFieldKeys.includes(fieldName);
};

export const getUpdatedFilters = (
    option: {
        value: FilterObject;
        label: string;
    },
    filters: FilterObject[]
) => {
    const baseFilters: FilterObject[] = filters.filter(
        (filterObj) =>
            // Base filters include filters that aren't related to editions array i.e. {jobTitle: 'manager'}
            // @ts-expect-error
            editionFieldFilterFunction(Object.keys(filterObj)[0]) ||
            // Base filters include period and sentSmsEditions filters
            Object.prototype.hasOwnProperty.call(filterObj, 'period') ||
            Object.prototype.hasOwnProperty.call(filterObj, 'sentSmsEditions')
    );
    let newFilters = baseFilters.concat(option.value);

    // To remove extra filters and show 'All recipients,' we just save the period filter
    // plus the sentSmsEditions filter and any that aren't related to editions array i.e. {jobTitle: 'manager'}
    if (option.value.sentSmsEditions) {
        const periodFilter: FilterObject[] = filters.filter(
            (filterObj) =>
                // @ts-expect-error
                editionFieldFilterFunction(Object.keys(filterObj)[0]) ||
                Object.prototype.hasOwnProperty.call(filterObj, 'period')
        );
        newFilters = periodFilter.concat(option.value);
    }

    return newFilters;
};
